/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesdelete1Inputs */

const en_filesdelete1 = /** @type {(inputs: Filesdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete file`)
};

const pt_filesdelete1 = /** @type {(inputs: Filesdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar ficheiro`)
};

/**
* | output |
* | --- |
* | "Delete file" |
*
* @param {Filesdelete1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesdelete1 = /** @type {((inputs?: Filesdelete1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesdelete1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesdelete1(inputs)
	return pt_filesdelete1(inputs)
});
export { filesdelete1 as "filesDelete" }